import React, { useContext, useEffect, useRef, useState } from "react";
import App from "../LayoutMobile";
import "./corporateCustomer.css";
import {
  Card,
  ConfigProvider,
  Form,
  message,
  Pagination,
  Checkbox,
  Upload,
  Popover,
  Table,
  Input,
  Select,
  Button,
  Space,
  Popconfirm,
  Typography,
  Row,
  Col,
  Spin,
} from "antd";
import {
  CheckOutlined,
  CloseCircleOutlined,
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  PaperClipOutlined,
  SearchOutlined,
  SwitcherOutlined,
} from "@ant-design/icons";
import {
  QuestionCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import axios from "axios";

import { Config } from "../Common/Config";
import { customDropdown } from "../Common/CommonFunction";
import { useForm } from "antd/es/form/Form";
import { Await } from "react-router-dom";
import CorporateCard from "../CorporateProduct/CorporateCard";
const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;
let data = [
  { companyName: "Alpha Corp", status: 1 },
  { companyName: "Apex Industries", status: 0 },
  { companyName: "Beta Solutions", status: 1 },
  { companyName: "Bright Tech", status: 0 },
  { companyName: "Core Systems", status: 1 },
  { companyName: "Creative Labs", status: 1 },
  { companyName: "Delta Enterprises", status: 0 },
  { companyName: "Dynamic Works", status: 1 },
  { companyName: "Eagle Vision", status: 0 },
  { companyName: "Elite Group", status: 1 },
  { companyName: "Future Innovations", status: 1 },
  { companyName: "Fusion Industries", status: 0 },
  { companyName: "Global Tech", status: 1 },
  { companyName: "Grand Corporation", status: 0 },
  { companyName: "Horizon Ventures", status: 1 },
  { companyName: "Hyper Networks", status: 0 },
  { companyName: "Iconic Holdings", status: 1 },
  { companyName: "Infinity Solutions", status: 1 },
  { companyName: "Jetstream Ltd", status: 0 },
  { companyName: "Jupiter Enterprises", status: 1 },
  { companyName: "Kingdom Corp", status: 0 },
  { companyName: "Keystone Tech", status: 1 },
  { companyName: "Legend Industries", status: 1 },
  { companyName: "Luminate Corp", status: 0 },
  { companyName: "Metro Systems", status: 1 },
  { companyName: "Momentum Group", status: 0 },
  { companyName: "Nova Technologies", status: 1 },
  { companyName: "NextEra Corp", status: 1 },
  { companyName: "Omni Enterprises", status: 0 },
  { companyName: "Orbit Solutions", status: 1 },
  { companyName: "Prime Holdings", status: 0 },
  { companyName: "Pinnacle Services", status: 1 },
  { companyName: "Quantum Tech", status: 1 },
  { companyName: "Quest Enterprises", status: 0 },
  { companyName: "Royal Industries", status: 1 },
  { companyName: "Rising Star Corp", status: 0 },
  { companyName: "Summit Tech", status: 1 },
  { companyName: "Synergy Group", status: 1 },
  { companyName: "Titan Systems", status: 0 },
  { companyName: "TopLine Ltd", status: 1 },
  { companyName: "Unity Corp", status: 0 },
  { companyName: "Ultra Holdings", status: 1 },
  { companyName: "Visionary Tech", status: 1 },
  { companyName: "Vortex Labs", status: 0 },
  { companyName: "Wisdom Enterprises", status: 1 },
  { companyName: "WinTech Corp", status: 0 },
  { companyName: "Xpert Solutions", status: 1 },
  { companyName: "Xylon Dynamics", status: 1 },
  { companyName: "Youth Innovations", status: 0 },
  { companyName: "YellowStone Corp", status: 1 },
  { companyName: "Zenith Technologies", status: 0 },
  { companyName: "Zigma Industries", status: 1 },
];

const CorporateCustomer = () => {
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [allCompanyData, setAllCompanyData] = useState({});
  const [clinicDataSetInUpdate, setclinicDataSet] = useState({});
  const [CurrentPage, setCurrentPage] = useState(1);
  const [carporateProducts, setCarporateProducts] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [isCompanyCreateEnable, setisCompanyCreateEnable] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [fileList, setFileList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [base64Image, setBase64Image] = useState(null);
  const [showAddButton, setshowAddButton] = useState(true);
  const [loader, setloader] = useState(false);
  const [showEditorOnlyAdd, setshowEditorOnlyAdd] = useState(true);
  const [copied, setCopied] = useState(false);
  const [showMiddleSection, setShowMiddleSection] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [showWidgetField, setShowWidgetField] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);
  const [limit, setLimit] = useState(20);
  const [letter, setLetter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  // const [status, setStatus] = useState(null);
  const [form] = useForm();

  useEffect(() => {
    getCorporateCustomer(letter, CurrentPage, limit, debouncedSearch);
    getCorporateProducts();
  }, [letter, CurrentPage, limit, debouncedSearch]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm.trim());
    }, 500); // wait 500 ms after typing stops

    return () => clearTimeout(handler); // cleanup old timer
  }, [searchTerm]);
  const getCorporateCustomer = async (
    letter = "",
    page = 1,
    limit = 20,
    search = ""
  ) => {
    setLoading(true);
    try {
      // let url = `${Config.url}corporate-customers/page/${page}`;

      // if (letter && letter !== "ALL") {
      //   url += `?letter=${letter.toLowerCase()}`;
      // }

      let url = `${Config.url}corporate-customers/page/${page}`;

      // optional filters
      const params = [];
      if (letter && letter !== "ALL")
        params.push(`letter=${letter.toLowerCase()}`);
      if (search) params.push(`search=${encodeURIComponent(search)}`);

      if (params.length) {
        url += `?${params.join("?")}`;
      }

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      // console.log(" response ::::", response?.data?.data);
      setAllCompanyData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.log("error in get data ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
      setLoading(false);
    }
  };

  // ✅ Convert file to base64
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  // ✅ Before upload validation
  const beforeUpload = async (file) => {
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("File size must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }

    // ✅ Convert to base64 manually
    const base64 = await getBase64(file);
    setBase64Image(base64);
    setFileList([file]);
    form.setFieldsValue({ company_logo: base64 }); // store base64 in form
    return false; // prevent actual upload
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length === 0) {
      setBase64Image(null);
      form.setFieldsValue({ company_logo: null });
    }
  };
  const getCorporateProducts = async () => {
    try {
      const response = await axios.get(`${Config.url}get-corporate-products`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      // console.log(" data ::::", response?.data?.data);
      setCarporateProducts(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.log("error in get data ::::", error);
      messageApi.error({
        type: "error",
        content:
          error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      });
      setLoading(false);
    }
  };
  const columns = [
    {
      title: "Company name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_, record) => (record?.status == 1 ? "Active" : "Inactive"),
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div style={{ textAlign: 'right', marginRight: 2 }}>
          <Popover
            placement="left"
            trigger="click"
            content={() => popoverContent(record)}
          >
            <button
              onClick={(e) => e.stopPropagation()}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontWeight: 700, fontSize: 18, letterSpacing: 2,
                color: '#008385', padding: '0 6px', lineHeight: 1,
              }}
            >···</button>
          </Popover>
        </div>
      ),
    },
  ];
  //   const uploadButton = (
  //     <button style={{ border: 0, background: "none" }} type="button">
  //       {loading ? <LoadingOutlined /> : <PlusOutlined />}
  //       <div style={{ marginTop: 8, alignItems: "flex-start" }}>Upload</div>
  //     </button>
  //   );
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a style={{ color: "#4A4A4A" }}>Previous</a>;
    }
    if (type === "next") {
      return <a style={{ color: "#4A4A4A" }}>Next</a>;
    }
    return originalElement;
  };
  const alphabets = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i)
  );
  // console.log("letter", letter);
  
  const buttons = ["ALL", ...alphabets];
  const onClickAlphabets = (letter, index) => {
    getCorporateCustomer(letter);
    setActiveIndex(index);
    setLetter(letter);
    setCurrentPage(1);
    // console.log("onClickAlphabets", letter, index);
  };
  const onFinish = (values) => {
    console.log("onFinish", values);
  };

  const handleSelectChange = (values) => {
    setSelected(values);
    form.setFieldsValue({ non_gp_product_ids: values });
  };

  const uploadButton = (
    <Input
      placeholder="Upload logo"
      readOnly
      suffix={<PaperClipOutlined />}
      style={{ cursor: "pointer" }}
    />
  );

  const openCorporateCustomerForm = (record, viewMode = false) => {
    setShowMiddleSection(false);
    setshowAddButton(false);
    setloader(true);
    setIsViewMode(viewMode);
    setisCompanyCreateEnable(true);
    setclinicDataSet(record);
    setshowEditorOnlyAdd(false);
    setShowWidgetField(true);

    const productIds =
      record.corporate_products?.map((p) => p.non_gp_product_id) || [];

    const logoFileList = record.company_logo
      ? [
          {
            uid: "-1",
            name: record.company_logo.split("/").pop(),
            status: "done",
            url: record.company_logo,
          },
        ]
      : [];

    setFileList(logoFileList);
    setSelected(productIds);

    form.setFieldsValue({
      name: record.name || "",
      email: record.email || "",
      intranet_url: record.intranet_url || "",
      page_url: record.page_url || "",
      requires_employee_number: !!record.requires_employee_number,
      allow_for_admin: !!record.allow_for_admin,
      change_category_label: !!record.change_category_label,
      product_category_label: record.product_category_label || "",
      non_gp_product_ids: productIds || [],
      widget_url: record.widget_url || "",
      company_logo: record.company_logo || "",
    });
    setloader(false);

    document
      .querySelector(".productcategory-form")
      ?.scrollIntoView({ behavior: "smooth" });
  };

  const popoverContent = (record) => {
    return (
      <div className="rule-action-popover" style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
        <div
          className="rule-action-item"
          style={{ color: '#008385' }}
          onClick={(e) => {
            e.stopPropagation();
            openCorporateCustomerForm(record, true);
          }}
        >
          <EyeOutlined style={{ fontSize: 15 }} /> View
        </div>
        <div
          className="rule-action-item"
          style={{ color: '#008385' }}
          onClick={(e) => {
            e.stopPropagation();
            openCorporateCustomerForm(record, false);
          }}
        >
          <EditOutlined style={{ fontSize: 15 }} /> Edit
        </div>
        <div className="rule-action-divider" />
        <Popconfirm
          title="Update status"
          description="Are you sure you want to update status?"
          onConfirm={() => updateStatus(record)}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          okButtonProps={{ className: 'confirmation-popup-ok-button' }}
          cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
          okText="Yes"
          cancelText="No"
        >
          <div className="rule-action-item" style={{ color: '#008385' }}>
            <SwitcherOutlined style={{ fontSize: 15 }} />
            {record && record.status == 1 ? 'Make Inactive' : 'Make Active'}
          </div>
        </Popconfirm>
        <div className="rule-action-divider" />
        <Popconfirm
          title="Delete"
          description="Are you sure you want to delete?"
          onConfirm={() => deleteCustomer(record)}
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          okButtonProps={{ className: 'confirmation-popup-ok-button' }}
          cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
          okText="Yes, Delete"
          cancelText="Cancel"
        >
          <div className="rule-action-item rule-action-item--delete">
            <DeleteOutlined style={{ fontSize: 15 }} /> Delete
          </div>
        </Popconfirm>
      </div>
    );
  };

  const handleCompanyCreate = async (values, update = false) => {
    // const values = await form.validateFields();
    let url = !update
      ? `${Config.url}corporate-customers`
      : `${Config.url}corporate-customers/${clinicDataSetInUpdate?.corporate_customer_id}`;

    const payload = {
      company_logo: base64Image || clinicDataSetInUpdate?.company_logo || "",
      name: values.name || "",
      email: values.email || "",
      requires_employee_number: values.requires_employee_number || false,
      allow_for_admin: values.allow_for_admin || false,
      change_category_label: values.change_category_label || false,
      product_category_label: values.product_category_label || '',
      page_url: values.page_url || "",
      intranet_url: values.intranet_url || "",
      non_gp_product_ids: values.non_gp_product_ids || [],
      widget_url: values.widget_url || "",
      ...(update ? { _method: "PUT" } : {}), // ✅ add only if update is true
      // status: status,
    };
    try {
      setIsSubmitting(true);
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (res.ok) {
        messageApi.success({
          type: "success",
          content: !update
            ? "Customer created successfully"
            : "Customer updated successfully",
        });
        // console.log("Response:", data);
        form.resetFields();
        setSelected([]);
        setFileList([]);
        getCorporateCustomer();
        setIsSubmitting(false);
        setisCompanyCreateEnable(false);
        setclinicDataSet({});
        setIsViewMode(false);
        setshowAddButton(true);
        setCurrentPage(1);
        setLetter("");
        setActiveIndex(null);
      } else {
        messageApi.error({
          type: "Error",
          content:
            res.message || !update
              ? "Failed to create customer"
              : "Failed to update customer",
        });
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Error creating company:", error);
      messageApi.error({
        type: "Error",
        content:
          error.message || !update
            ? "Failed to create customer"
            : "Failed to update customer",
      });
      setIsSubmitting(false);
    }
  };

  const updateStatus = async (record) => {
    if (!record?.corporate_customer_id) {
      return;
    }
    setloader(true);
    let url = `${Config.url}corporate-customers/${record.corporate_customer_id}`;
    try {
      const response = await axios.put(
        url,
        {
          status: record.status == 1 ? 0 : 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // console.log(' Successful:', response);
      if (response?.data?.success) {
        messageApi.success({
          type: "succes",
          content: "Corporate customer status updated successfully",
        });
        setloader(false);
        getCorporateCustomer();
      }
    } catch (error) {
      messageApi.error({
        type: "error",
        content: "Something Went wrong",
      });
      console.log("update user:", error.response?.data || error.message);
      // throw error;
    }
    setloader(false);
  };

  const deleteCustomer = async (record) => {
    const url = `${Config.url}corporate-customers/${record.corporate_customer_id}`; // ✅ correct endpoint
    try {
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      messageApi.success("Customer deleted successfully");
      getCorporateCustomer();
    } catch (error) {
      console.error("Delete error:", error.response?.data || error.message);
      messageApi.error(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    }
  };

  const handleCopy = () => {
    const value = form.getFieldValue("widget_url");
    if (value) {
      navigator.clipboard.writeText(value);
      setCopied(true);
      message.success("Copied to clipboard!");
      setTimeout(() => setCopied(false), 2000); // revert after 2 seconds
    }
  };

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    return parts.slice(0, 2).map(p => p[0]?.toUpperCase()).join('');
  };

  return (
    <App>
      {contextHolder}
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            padding: "0 116px",
            // marginBottom: 15,
          }}
        >
          {allCompanyData && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginBottom: "10px",
              }}
            >
              <Title
                level={5}
                style={{ margin: 0, color: "#008385", fontSize: 20 }}
              >
                All customers{" "}
                <span style={{ color: "black", fontWeight: "400" }}>
                  ({allCompanyData?.total ? allCompanyData.total : "00"})
                </span>
              </Title>
            </div>
          )}
          <div
            style={{
              display: "grid",
              justifyContent: "space-between",
              marginBottom: 15,
            }}
          >
            <Input
              prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
              placeholder="Search for a customer"
              style={{ width: "215px", height: 40 }}
              onChange={(e) => {
                setCurrentPage(1);
                setSearchTerm(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Card
          className="addClinic-table"
          style={{
            width: 950,
            margin: 0,
            padding: 0,
            borderRadius: 50,
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
          }}
        >
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#008385",
                  headerColor: "#ffffff",
                },
                Spin: {
                  colorPrimary: "#008385", // Change this to your desired color
                },
              },
            }}
          >
            <Table
              loading={loading}
              className="corporate-customer-table"
              columns={columns}
              dataSource={allCompanyData.data}
              pagination={false}
              onRow={(record) => ({
                onClick: () => {
                  setShowMiddleSection(true);
                  setisCompanyCreateEnable(false);
                  setclinicDataSet(record);
                },
                style: { cursor: "pointer" },
              })}
              scroll={{
                x: "auto",
              }}
            />
            {allCompanyData && allCompanyData?.total ? (
              <Pagination
                align="center"
                // defaultCurrent={1}
                // defaultPageSize={20}
                pageSize={limit}
                className="corporate-customer-pagination"
                total={allCompanyData?.total || 0}
                style={{ marginTop: 10 }}
                current={CurrentPage}
                onChange={(page, size) => {
                  setCurrentPage(page);
                  setLimit(size || 10);
                }}
                itemRender={itemRender}
              />
            ) : (
              ""
            )}
            <div
              style={{
                display: "flex",
                flexWrap: "nowrap",
                gap: "4px",
                marginTop: 10,
                justifyContent: "center",
              }}
            >
              {buttons.map((letter, index) => (
                <Button
                  key={letter}
                  type="default"
                  onClick={() => onClickAlphabets(letter, index)}
                  style={{
                    padding: "4px 8px",
                    fontSize: "12px",
                    cursor: "pointer",
                    backgroundColor:
                      activeIndex === index ? "#0083851a" : "#f5f5f5",
                    border:
                      activeIndex === index
                        ? "1px solid #008385"
                        : "1px solid #d9d9d9",
                    color: activeIndex === index ? "#008385" : "inherit",
                    // fontWeight: activeIndex === index ? 600 : 500,
                    transition: "all 0.2s ease",
                  }}
                >
                  {letter}
                </Button>
              ))}
            </div>
          </ConfigProvider>
        </Card>
      </div>
      {showAddButton && (
        <div
          className="clinicCreate-form button-add-left"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Button
            className="add-generic-btn"
            onClick={() => {
              setIsViewMode(false);
              form.setFieldsValue({
                name: "",
                email: "",
                intranet_url: "",
                page_url: "",
                requires_employee_number: false,
                allow_for_admin: false,
                change_category_label: false,
                product_category_label: "",
                non_gp_product_ids: [],
                widget_url: "",
              });
              setisCompanyCreateEnable(true);
              setSelected([]);
              setShowMiddleSection(false);
              setShowWidgetField(false);
              setclinicDataSet({});
              setFileList([]);
            }}
          >
            Add a company
          </Button>
        </div>
      )}

      {showMiddleSection && (
        <div
          className="middle-customer-details"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "20px 0",
          }}
        >
          <CorporateCard
            setShowMiddleSection={setShowMiddleSection}
            clinicDataSetInUpdate={clinicDataSetInUpdate}
            setshowAddButton={setshowAddButton}
          />
        </div>
      )}

      {isCompanyCreateEnable && (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 10 }}
        >
          <Card
            className={`productcategory-form${isViewMode ? ' view-mode-card' : ''}`}
            style={{ width: 750, height: 'fit-content' }}
            title={
              isViewMode ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{
                    width: 40, height: 40, borderRadius: '50%',
                    background: 'linear-gradient(135deg, #008385, #00a3a5)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontWeight: 700, fontSize: 16, flexShrink: 0,
                    boxShadow: '0 2px 6px rgba(0,131,133,0.30)',
                  }}>
                    {getInitials(clinicDataSetInUpdate?.name)}
                  </div>
                  <span style={{ fontWeight: 700, fontSize: 16, color: '#007a7c' }}>
                    {clinicDataSetInUpdate?.name || 'Company'}
                  </span>
                </div>
              ) : 'Company details'
            }
          >
            {/* ── VIEW MODE: clean label/value rows ── */}
            {clinicDataSetInUpdate && loader === false && (isViewMode ? (
              <div style={{ padding: '0 4px' }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#008385', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8, paddingBottom: 4, borderBottom: '1px solid #c5e8e8' }}>Company Information</div>
                <div className="view-detail-row">
                  <label>Company Name</label>
                  <span className="view-field-value">{clinicDataSetInUpdate?.name || '-'}</span>
                </div>
                <div className="view-detail-row">
                  <label>Company Email</label>
                  <span className="view-field-value">{clinicDataSetInUpdate?.email || '-'}</span>
                </div>
                <div className="view-detail-row">
                  <label>Products</label>
                  <span className="view-field-value">
                    {(clinicDataSetInUpdate?.corporate_products || [])
                      .map(p => p.name)
                      .join(', ') || '-'}
                  </span>
                </div>
                <div className="view-detail-row">
                  <label>Intranet URL</label>
                  <span className="view-field-value">{clinicDataSetInUpdate?.intranet_url || '-'}</span>
                </div>
                {showWidgetField && (
                  <div className="view-detail-row">
                    <label>Booking Widget Link</label>
                    <span className="view-field-value">{clinicDataSetInUpdate?.widget_url || '-'}</span>
                  </div>
                )}
                <div className="view-detail-row">
                  <label>Booking Page Link</label>
                  <span className="view-field-value">{clinicDataSetInUpdate?.page_url || '-'}</span>
                </div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#008385', letterSpacing: 1, textTransform: 'uppercase', margin: '12px 0 8px', paddingBottom: 4, borderBottom: '1px solid #c5e8e8' }}>Settings</div>
                <div className="view-detail-row">
                  <label>Member / Employee No.</label>
                  <span className="view-field-value">{clinicDataSetInUpdate?.requires_employee_number ? 'Required' : 'Not required'}</span>
                </div>
                <div className="view-detail-row">
                  <label>Allow Booking for CSR</label>
                  <span className="view-field-value">{clinicDataSetInUpdate?.allow_for_admin ? 'Yes' : 'No'}</span>
                </div>
                <div className="view-detail-row">
                  <label>Change Category Label</label>
                  <span className="view-field-value">{clinicDataSetInUpdate?.change_category_label ? 'Yes' : 'No'}</span>
                </div>
                {clinicDataSetInUpdate?.change_category_label && (
                  <div className="view-detail-row">
                    <label>Category Label</label>
                    <span className="view-field-value">{clinicDataSetInUpdate?.product_category_label || '-'}</span>
                  </div>
                )}
                <div style={{ display: 'flex', gap: 12, marginTop: 20, paddingBottom: 4 }}>
                  <Button
                    onClick={() => {
                      form.setFieldsValue({ name: '', email: '', intranet_url: '', page_url: '', requires_employee_number: false, allow_for_admin: false, change_category_label: false, product_category_label: '', non_gp_product_ids: [], widget_url: '' });
                      setisCompanyCreateEnable(false); setSelected([]); setFileList([]); setshowAddButton(true); setclinicDataSet({}); setIsViewMode(false);
                    }}
                    style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}
                  >Cancel</Button>
                  <Button
                    className="edit-btn-green"
                    icon={<EditOutlined />}
                    onClick={() => setIsViewMode(false)}
                    style={{ minWidth: 100 }}
                  >Edit</Button>
                </div>
              </div>
            ) : (
              <Form
                layout="vertical"
                onFinish={(values) =>
                  handleCompanyCreate(
                    values,
                    Object.keys(clinicDataSetInUpdate)?.length &&
                      clinicDataSetInUpdate.corporate_customer_id
                      ? true
                      : false
                  )
                }
                form={form}
                initialValues={
                  clinicDataSetInUpdate ? clinicDataSetInUpdate : null
                }
              >
                <Row style={{ maxHeight: "88px" }} gutter={24}>
                  <Col span={12}>
                    <Form.Item
                      label="Company Name:"
                      name="name"
                      rules={[
                        {
                          required: !isViewMode,
                          message: "Company Name is required.",
                        },
                      ]}
                    >
                      <Input
                        disabled={isViewMode}
                        style={{ width: "100%" }}
                        placeholder="Company Name"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Product:"
                      name="non_gp_product_ids"
                      rules={[
                        {
                          required: !isViewMode,
                          message: "At least 1 Product is required",
                        },
                      ]}
                    >
                      <Select
                        disabled={isViewMode}
                        mode="multiple"
                        className="products-list-dp"
                        placeholder="Select products"
                        value={selected}
                        showSearch
                        open={dropdownOpen}
                        onDropdownVisibleChange={(open) =>
                          setDropdownOpen(open)
                        }
                        onFocus={() => setSearchValue("")}
                        onSearch={(val) => setSearchValue(val)}
                        filterOption={false} // disable default filtering
                        // dropdownRender={() => (
                        //   <div style={{ padding: 8 }}>
                        //     {carporateProducts?.map((clType) => (
                        //       <div key={clType.non_gp_product_id}>
                        //         <Checkbox
                        //           checked={selected.includes(
                        //             clType.non_gp_product_id
                        //           )}
                        //           onChange={(e) => {
                        //             const value = clType.non_gp_product_id;
                        //             const updated = e.target.checked
                        //               ? [...selected, value]
                        //               : selected.filter((id) => id !== value);

                        //             setSelected(updated);
                        //             form.setFieldsValue({
                        //               non_gp_product_ids: updated,
                        //             });
                        //           }}
                        //         >
                        //           {clType.name}
                        //         </Checkbox>
                        //       </div>
                        //     ))}
                        //   </div>
                        // )}
                        dropdownRender={() => {
                          // Filter based on the search input
                          const filteredProducts = carporateProducts?.filter(
                            (item) =>
                              item.name
                                .toLowerCase()
                                .includes(searchValue.toLowerCase())
                          );

                          return (
                            <div
                              style={{
                                padding: 8,
                                maxHeight: 300,
                                overflowY: "auto",
                              }}
                            >
                              {filteredProducts?.length ? (
                                filteredProducts.map((clType) => (
                                  <div key={clType.non_gp_product_id}>
                                    <Checkbox
                                      disabled={isViewMode}
                                      checked={selected.includes(
                                        clType.non_gp_product_id
                                      )}
                                      onChange={(e) => {
                                        const value = clType.non_gp_product_id;
                                        const updated = e.target.checked
                                          ? [...selected, value]
                                          : selected.filter(
                                              (id) => id !== value
                                            );
                                        setSelected(updated);
                                        form.setFieldsValue({
                                          non_gp_product_ids: updated,
                                        });
                                      }}
                                    >
                                      {clType.name}
                                    </Checkbox>
                                  </div>
                                ))
                              ) : (
                                <div
                                  style={{ padding: "8px 12px", color: "#999" }}
                                >
                                  No matching results
                                </div>
                              )}
                            </div>
                          );
                        }}
                        // ✅ This controls how many tags show before summarizing
                        // maxTagCount={2}
                        maxTagPlaceholder={(omittedValues) =>
                          `+${omittedValues.length} more`
                        }
                        onChange={(values) => {
                          setSelected(values);
                          form.setFieldsValue({
                            non_gp_product_ids: values,
                          });
                        }}
                      >
                        {carporateProducts?.map((clType) => (
                          <Select.Option
                            key={clType.non_gp_product_id}
                            value={clType.non_gp_product_id}
                          >
                            {clType.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item
                      label="Company Email:"
                      name="email"
                      rules={
                        ([
                          {
                            required: false,
                            message: "Email is required.",
                            type: "email",
                          },
                        ],
                        [
                          {
                            message: "Please enter valid email address.",
                            type: "email",
                          },
                        ])
                      }
                    >
                      <Input
                        disabled={isViewMode}
                        style={{ width: "100%" }}
                        placeholder="email"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item
                      label="Company Logo:"
                      name="company_logo"
                      rules={[
                        { required: false, message: "Logo is required." },
                      ]}
                      className="customer-logo"
                    >
                      <Upload
                        disabled={isViewMode}
                        listType={"picture-card"}
                        onChange={handleChange}
                        maxCount={1}
                        beforeUpload={beforeUpload}
                        fileList={fileList}
                        accept="image/*"
                        showUploadList={{
                          showPreviewIcon: false,
                          showRemoveIcon: true,
                          showDownloadIcon: false,
                        }}
                      >
                        <Input
                          placeholder={
                            Object.keys(clinicDataSetInUpdate)?.length > 0 ||
                            fileList?.length > 0
                              ? fileList?.length > 0
                                ? fileList[0]?.name // 👈 user uploaded a new file
                                : "Upload logo" // 👈 existing logo
                              : "Upload logo" // 👈 creating new
                          }
                          value={
                            Object.keys(clinicDataSetInUpdate)?.length > 0 &&
                            fileList?.length === 0
                              ? ""
                              : ""
                          }
                          readOnly
                          suffix={<PaperClipOutlined />}
                          style={{ cursor: "pointer" }}
                        />
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item
                      label="Intranet url:"
                      name="intranet_url"
                      rules={[
                        {
                          required: false,
                          message: "Intranet url is required.",
                        },
                      ]}
                    >
                      <Input
                        disabled={isViewMode}
                        style={{ width: "100%" }}
                        placeholder="Intranet url"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    {Object.keys(clinicDataSetInUpdate).length > 0 &&
                      showWidgetField && (
                        <Form.Item
                          label="Booking widget link:"
                          name="widget_url"
                          rules={[
                            {
                              required: !isViewMode,
                              message: "Booking widget link is required.",
                            },
                          ]}
                        >
                          <Input
                            suffix={
                              copied ? (
                                <span style={{ color: "green", fontSize: 12 }}>
                                  <CheckOutlined /> Copied
                                </span>
                              ) : (
                                <CopyOutlined
                                  style={{
                                    cursor: "pointer",
                                    color: "#1677ff",
                                  }}
                                  onClick={handleCopy}
                                />
                              )
                            }
                            style={{ width: "100%" }}
                            placeholder="Booking widget link"
                            disabled
                          />
                        </Form.Item>
                      )}
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item
                      label="Booking page link:"
                      name="page_url"
                      rules={[
                        {
                          required: false,
                          message: "Booking page link is required.",
                        },
                      ]}
                    >
                      <Input
                        disabled={isViewMode}
                        style={{ width: "100%" }}
                        placeholder="Booking page link"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col
                    style={{ display: "flex", justifyContent: "left" }}
                    span={12}
                  >
                    <Form.Item
                      name="requires_employee_number"
                      valuePropName="checked"
                      initialValue={false}
                      rules={[
                        {
                          required: false,
                          message:
                            "Request for member/employee number is required.",
                        },
                      ]}
                    >
                      <Checkbox disabled={isViewMode}>Request Member/ employee number</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col
                    style={{ display: "flex", justifyContent: "left" }}
                    span={12}
                  >
                    <Form.Item
                      name="allow_for_admin"
                      valuePropName="checked"
                      initialValue={false}
                      rules={[
                        {
                          required: false,
                          message:
                            "Request for Allow booking for CSR is required.",
                        },
                      ]}
                    >
                      <Checkbox disabled={isViewMode}>Allow booking for CSR</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col
                    style={{ display: "flex", justifyContent: "left" }}
                    span={12}
                  >
                    <Form.Item
                      name="change_category_label"
                      valuePropName="checked"
                      initialValue={false}
                      rules={[
                        {
                          required: false,
                          message:
                            "Change category label is required.",
                        },
                      ]}
                    >
                      <Checkbox disabled={isViewMode}>Change category label</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.change_category_label !== currentValues.change_category_label}>
                  {({ getFieldValue }) =>
                    getFieldValue('change_category_label') ? (
                      <Row gutter={24}>
                        <Col span={12}>
                          <Form.Item
                            label="Product category label:"
                            name="product_category_label"
                            rules={[
                              {
                                required: false,
                                message: "Product category label is required.",
                              },
                            ]}
                          >
                            <Input
                              disabled={isViewMode}
                              style={{ width: "100%" }}
                              placeholder="Product category label"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    ) : null
                  }
                </Form.Item>
                {isViewMode ? null : (
                  <>
                    <Button
                      disabled={isSubmitting}
                      loading={isSubmitting}
                      type="primary"
                      htmlType="submit"
                      style={{
                        marginTop: 10,
                        backgroundColor: "#008385",
                        width: "174px",
                        marginRight: 10,
                        height: "40px",
                        color: "white",
                      }}
                    >
                      {isSubmitting ? "Saving..." : "Save"}
                    </Button>
                    <Button
                      key="cancel-edit-btn"
                      type="primary"
                      htmlType="button"
                      className="add-generic-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        form.setFieldsValue({
                          name: "",
                          email: "",
                          intranet_url: "",
                          page_url: "",
                          requires_employee_number: false,
                          allow_for_admin: false,
                          change_category_label: false,
                          product_category_label: "",
                          non_gp_product_ids: [],
                          widget_url: "",
                        });
                        setisCompanyCreateEnable(false);
                        setSelected([]);
                        setFileList([]);
                        setshowAddButton(true);
                        setclinicDataSet({});
                        setIsViewMode(false);
                      }}
                      style={{
                        marginTop: 10,
                        backgroundColor: "#fafefeff",
                        width: "174px",
                        height: "40px",
                      }}
                    >
                      Cancel
                    </Button>
                  </>
                )}
              </Form>
            ))}
          </Card>
        </div>
      )}
    </App>
  );
};
export default CorporateCustomer;
